<template>
    <div>
        <div v-if="loading" class="loading"/>

        <FilesList v-else :files="files" @delete="deleteFile"/>

        <FileDelete v-if="file" :file="file" :base-url="base_url" @updated="getFiles($route.params.facility_id)"/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import FilesList from "../../../../../components/Listing/FilesList";
    import FileDelete from "../../../../../components/Modal/FileDelete";

    export default {
        name: "FacilityFilesList",

        components: {
            FileDelete,
            FilesList
        },

        data() {
            return {
                loading: true,
                base_url: '/api/hms/locations/facilities/' + this.$route.params.facility_id + '/attachments',
                file: null,
            }
        },

        computed: {
            ...mapGetters({
                files: 'getFacilityFiles',
            }),
        },

        mounted() {
            this.getFiles(this.$route.params.facility_id);
        },

        methods: {
            async getFiles(facility_id) {
                await this.$store.dispatch('fetchFacilityFiles', facility_id);

                return this.loading = false;
            },

            deleteFile(file) {
                this.file = file;

                setTimeout(() => {
                    this.$bvModal.show('file_delete');
                }, 1);
            },
        }
    }
</script>

<style scoped>

</style>
